/* eslint-disable i18next/no-literal-string */
import React, { Dispatch, SetStateAction } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { FormInput } from 'app/components/Common/Form/FormInput';

export enum IApproverType {
  amn = 'amn',
  client = 'client',
}

export const ApproverType = ({
  control,
  customClasses,
  setSelectedApproverType,
}: {
  control: Control<Record<string, any>>;
  customClasses: string;
  setSelectedApproverType: Dispatch<SetStateAction<IApproverType>>;
}) => {
  return (
    <FormInput label={'Approver Type'} customClasses={customClasses}>
      <Controller
        control={control}
        name={'approverType'}
        render={({ field: { onChange, ...rest } }) => (
          <RadioGroup
            row
            {...rest}
            onChange={event => {
              onChange(event.target.value);
              setSelectedApproverType(event.target.value as IApproverType);
            }}
            name={'approverType'}
          >
            <FormControlLabel
              label="AMN"
              value={IApproverType.amn}
              labelPlacement="end"
              control={<Radio color="primary" />}
            />
            <FormControlLabel
              label="Client"
              value={IApproverType.client}
              labelPlacement="end"
              control={<Radio color="primary" />}
            />
          </RadioGroup>
        )}
      />
    </FormInput>
  );
};
